import { useMemo, useState } from 'react';

const EMPTY = Object.freeze([]);

/** Rows a table or a group lists before the reader asks for the rest. */
export const DRILL_PREVIEW = 10;

/**
 * A long list shown short until asked.
 *
 * `preview` is how much shows by default: a number of rows, or a function that
 * picks the subset worth showing first (the names above a threshold, say).
 * `false` shows everything. Pairs with `<ShowAll>`, which draws the control;
 * this owns the state, so a table's "show all" reads and behaves the same
 * wherever it appears. `reset` puts the list back to its short form, for a
 * caller whose rows have changed under the reader.
 */
export function usePreview(rows, preview) {
  const [all, setAll] = useState(false);

  const shown = useMemo(() => {
    const list = rows ?? EMPTY;
    if (all || !preview) return list;
    return typeof preview === 'function' ? preview(list) : list.slice(0, preview);
  }, [rows, all, preview]);

  const total = rows?.length ?? 0;
  return {
    shown,
    all,
    total,
    hidden: total - shown.length,
    toggle: () => setAll((v) => !v),
    reset: () => setAll(false),
  };
}
